import React from 'react'
import { arrayOf, func, number, oneOfType, string } from 'prop-types'

import { Item, List, Text } from './styles'

import Slider from './slider'

class ValuePicker extends React.Component {
  componentDidMount() {
    this.slider = new Slider({
      el: this.el,
      startIndex: this.props.startIndex,
      onSlide: this.props.onChange
    })
  }

  componentWillUnmount() {
    this.slider.destroy()
  }

  render() {
    const { values, id } = this.props

    return (
      <div>
        <List
          id={id}
          innerRef={el => {
            this.el = el
          }}
        >
          {values.map((value, index) => (
            <Item key={index}>
              <Text>{value}</Text>
            </Item>
          ))}
        </List>
      </div>
    )
  }
}

ValuePicker.defaultProps = {
  startIndex: 2,
  onChange: null
}

ValuePicker.propTypes = {
  values: arrayOf(oneOfType([number, string])).isRequired,
  startIndex: number,
  onChange: func
}

export default ValuePicker



// WEBPACK FOOTER //
// ./src/app/modules/ValuePicker/index.js